(function() {
    angular
        .module("app")
        .controller("WzQwsConfirmRemoveOutputInputDeviceController", WzQwsConfirmRemoveOutputInputDeviceController)

    WzQwsConfirmRemoveOutputInputDeviceController.$inject = [
        "$scope",
        "$uibModalInstance",
        "confirm",
        "deviceType",
        "name"
    ]

    function WzQwsConfirmRemoveOutputInputDeviceController(
        $scope,
        $uibModalInstance,
        confirm,
        deviceType,
        name
    ){
        "use strict"

        $scope.deviceType = deviceType
        $scope.name       = name

        $scope.cancel = () => {
            $uibModalInstance.dismiss("cancel")
        }

        $scope.confirm = () => {
            $uibModalInstance.close(confirm())
        }
    }
})()
